var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>\n    <form action=\"\" name=\"double-password-request\">\n        <div class=\"form-group\">\n            <input type=\"password\"\n                   class=\"form-control\"\n                   name=\"password\"\n                   placeholder=\"Digite sua senha\"\n                   data-field=\"double-password-request.password\"/>\n        </div>\n\n        <div class=\"alert alert-warning\">\n            <i class=\"fa fa-warning\"></i>\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"message") || (depth0 != null ? lookupProperty(depth0,"message") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"message","hash":{},"data":data,"loc":{"start":{"line":13,"column":12},"end":{"line":13,"column":27}}}) : helper))) != null ? stack1 : "")
    + "\n        </div>\n    </form>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./resources/assets/javascript/templates/double-password-request.hbs
// module id = ./resources/assets/javascript/templates/double-password-request.hbs
// module chunks = 53